import React, { useEffect, useState } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import UserRoles from '../../components/Config/Role/UserRoles';
import ConfigHome from '../../components/Config/ConfigHome';
import { useConfig } from '../../DataStore/ConfigContext';
import navItems from '../../components/Config/configItems';
import SystemUsers from '../../components/Config/User/SystemUsers';
import AlertDeleteUser from '../../components/Config/User/AlertDeleteUser';
import SchoolFeesConfig from '../../components/Config/SchoolFees/SchoolFeesConfig';
import SpecialAccountsConfig from '../../components/Config/SchoolFees/SpecialAccountsConfig';
import GatewayConfig from '../../components/Config/Gateways/GatewayConfig';
import GymConfig from '../../components/Config/Gym/GymConfig';
import CompanyProfile from '../../components/Config/Profile/CompanyProfile';
import ReportSignature from '../../components/Config/Sign/ReportSignature';
import AlertDeleteSignatory from '../../components/Config/Sign/AlertDeleteSignatory';
import Permission from '../../components/Config/Role/Permission';
import PopAssignRolePermission from '../../components/Config/Role/PopAssignRolePermission';
import AlertRevokePermission from '../../components/Config/Role/AlertRevokePermission';
import RolePermission from '../../components/Config/Role/RolePermission';
import PopChangeUserRole from '../../components/Config/Role/PopChangeUserRole';
import PreferenceHome from '../../components/Config/Preference/PreferenceHome';
import KeyConfig from '../../components/Config/Keys/KeyConfig';


const ConfigPage = () => {
    const { activeMenu, dispatch, companyCode } = useConfig();
    const themeColor = "#4F46E5";
    const filteredNavItems = navItems[companyCode] || navItems['GENERAL'];

    const [activeComponent, setActiveComponent] = useState(<ConfigHome menuItems={filteredNavItems}/>);
    
    useEffect(() => {
        setActiveComponent(renderActiveComponent(activeMenu));
    }, [activeMenu]);

    const handleMenuClick = (id) => {
        dispatch({ type: 'activeMenu', payload: id });
    };

     const renderActiveComponent = (menuId) => {
        const componentMapping = {
            1: <UserRoles />,
            2: <SystemUsers />,
            3: <Permission />,
            4: <CompanyProfile />,
            5: <SpecialAccountsConfig />,
            6: <PreferenceHome />,
            7: <SchoolFeesConfig />,
            8: <GatewayConfig />,
            9: <ReportSignature />,
            11: <KeyConfig />,
            10: <GymConfig />,
            15: <RolePermission />,

        };
        return componentMapping[menuId] || <ConfigHome menuItems={filteredNavItems} />;
    };

    return (
        <>
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="System Settings"
                    description="Configure your system settings and preferences"
                    iconClass="fa fa-cog"
                />
                
                <div className="row mt-3">
                    {/* Left Navigation Menu */}
                    <div className="col-md-3">
                        <div className="card border-0 shadow-sm" style={{ borderRadius: '16px' }}>
                            <div className="card-body p-3">
                                <nav className="nav flex-column">
                                    {Array.isArray(filteredNavItems) && filteredNavItems.map((item) => {
                                        const isActive = item.id === activeMenu;
                                        return (
                                            <div
                                                key={item.id}
                                                className={`nav-link d-flex align-items-center mb-1 cursor-pointer transition-all`}
                                                onClick={() => handleMenuClick(item.id)}
                                                style={{
                                                    borderRadius: '10px',
                                                    padding: '12px 16px',
                                                    fontSize: '14px',
                                                    fontWeight: isActive ? '700' : '500',
                                                    backgroundColor: isActive ? '#EEF2FF' : 'transparent',
                                                    color: isActive ? themeColor : '#64748B',
                                                    cursor: 'pointer',
                                                    transition: '0.2s'
                                                }}
                                            >
                                                <i className={`fa ${item.icon} mr-3`} style={{ 
                                                    width: '20px', 
                                                    textAlign: 'center',
                                                    fontSize: '16px'
                                                }}></i> 
                                                {item.label}
                                            </div>
                                        );
                                    })}
                                </nav>
                            </div>
                        </div>
                    </div>

                    {/* Main Settings Form */}
                    <div className="col-md-9" style={{ maxHeight: '80vh', overflowY: 'auto', scrollbarWidth: 'none' }}>
                        <div className="pl-md-2">
                             {activeComponent}
                        </div>
                    </div>
                </div>
            </MainContent>
        
        </PageContainer>

         <AlertDeleteUser />
            <AlertDeleteSignatory />
            <PopAssignRolePermission />
            <AlertRevokePermission />
            <PopChangeUserRole />

            <style>{`
                .cursor-pointer { cursor: pointer; }
                .nav-link:hover { 
                    background-color: #F8FAFC !important; 
                    color: ${themeColor} !important;
                }
            `}</style>
        </>
    );
};

export default ConfigPage;
